
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class ReadingSet(
    val id: String,
    val title: String,
    @SerialName("task_type") val taskType: Int,
    // Новые поля (nullable, так как у обычных задач их нет)
    @SerialName("audio_url") val audioUrl: String? = null,
    @SerialName("full_text") val fullText: String? = null,
    @SerialName("options_pool") val optionsPool: List<PoolOption>? = null
)

@Serializable
data class PoolOption(
    val id: String,   // "a", "b"...
    val text: String  // "terraza", "diez"...
)

@Serializable
data class UserProgress(
    @SerialName("task_id") val taskId: Int,     // Тип задачи (1, 2, 3...)
    @SerialName("set_id") val setId: String? = null, // Уникальный ID набора (UUID), который решен
    val score: Int,
    @SerialName("total_questions") val totalQuestions: Int
)

enum class Screen {
    WELCOME,                // Главный экран (бывший HOME)
    READING_MODE_SELECTION, // Выбор: Экзамен или Задачи (бывший SELECTION)
    READING_MENU,           // Список задач 1-5
    PRACTICE_RUNNING,       // Решение задачи
    EXAM_RUNNING,            // Режим экзамена (заглушка),
    LISTENING_MENU,         // Меню Аудирования
    LISTENING_MODE_SELECTION,         // Меню Аудирования
    LISTENING_RUNNING,
    STATISTICS,
    ADMIN_GENERATOR
}

@Serializable
data class ProgressUploadDto(
    @SerialName("user_id") val userId: String,
    @SerialName("task_id") val taskId: Int,
    @SerialName("set_id") val setId: String,
    val score: Int,
    @SerialName("total_questions") val totalQuestions: Int,
    @SerialName("updated_at") val updatedAt: String
)

@Serializable
data class ReadingQuestion(
    val id: String,
    @SerialName("set_id") val setId: String,
    @SerialName("text_content") val textContent: String,
    val question: String,

    @SerialName("option_a") val optionA: String,
    @SerialName("option_b") val optionB: String,
    @SerialName("option_c") val optionC: String,

    // Новые поля (могут быть null)
    @SerialName("option_d") val optionD: String? = null,
    @SerialName("option_e") val optionE: String? = null,

    @SerialName("correct_option") val correctOption: String,
    @SerialName("order_index") val orderIndex: Int
)

@Serializable
data class TaskAttempt(
    val id: String? = null,
    @SerialName("user_id") val userId: String? = null, // Заполняется на бэке или при отправке
    @SerialName("task_id") val taskId: Int,
    @SerialName("set_title") val setTitle: String,
    val score: Int,
    @SerialName("total_questions") val totalQuestions: Int,
    @SerialName("duration_seconds") val durationSeconds: Int,
    val details: List<AttemptDetail>, // Наш JSONB
    @SerialName("created_at") val createdAt: String? = null
)

@Serializable
data class AttemptDetail(
    val question: String,      // Текст вопроса
    @SerialName("user_answer") val userAnswer: String,  // Что ответил юзер
    @SerialName("correct_answer") val correctAnswer: String, // Правильный ответ
    @SerialName("is_correct") val isCorrect: Boolean
)